import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getGallery } from "../actions/ApiCalls";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import {IMAGE_URL} from "../path";
import './Story.css';

function Gallery() {
    const { slug } = useParams<{ slug?: string }>();
    const navigate = useNavigate();
    const [gallery, setGallery] = useState<any>(null);
    const [screenSize, setScreenSize] = useState({
        width: window.innerWidth,
        isDesktop: window.innerWidth > 950,
        isTablet: window.innerWidth <= 950 && window.innerWidth > 575,
        isMobile: window.innerWidth <= 575,
    });

    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [photoIndex, setPhotoIndex] = useState(0);

    const linkStyle: React.CSSProperties = {
        color: 'black',
        fontSize: '10px',
        fontFamily: "'Vinimark-Diatype', sans-serif",
        fontWeight: 600,
        textTransform: 'uppercase',
        textDecoration: 'underline',
        cursor: 'pointer',
    };

    useEffect(() => {
        if (slug) {
            getGallery(slug)
                .then((response) => {
                    const g = response.data.gallery;
                    setGallery(g);
                    document.title = "Vinimark | Gallery | " + g?.title;
                })
                .catch((error) => {
                    console.error("Failed to fetch gallery:", error);
                });
        }
    }, [slug]);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            setScreenSize({
                width,
                isDesktop: width > 950,
                isTablet: width <= 950 && width > 575,
                isMobile: width <= 575,
            });
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const handleKey = (e: KeyboardEvent) => {
            if (!lightboxOpen) return;
            if (e.key === "Escape") setLightboxOpen(false);
            if (e.key === "ArrowRight")
                setPhotoIndex((i) => (i + 1) % (gallery?.images?.length || 1));
            if (e.key === "ArrowLeft")
                setPhotoIndex(
                    (i) =>
                        (i + (gallery?.images?.length || 1) - 1) %
                        (gallery?.images?.length || 1)
                );
        };
        window.addEventListener("keydown", handleKey);
        return () => window.removeEventListener("keydown", handleKey);
    }, [lightboxOpen, gallery]);

    if (!gallery)
        return (
            <div>
                <Header />
                <div style={{ minHeight: "85vh" }}></div>
                <Footer />
            </div>
        );

    // Only use the images array, skip cover_image
    const images = gallery.images?.map((img: any) => IMAGE_URL  + img.image_path) || [];

    return (
        <div
            style={{
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                width: "100%",
            }}
        >
            <Header />

            <div style={{minHeight: "85vh"}}>
                {/* Title & Description */}

                <div
                    style={{
                        marginTop: "130px",
                        display: "flex",
                        flexDirection: screenSize.isMobile ? "column" : "row",
                        gap: "20px",
                        marginBottom: '30px'

                    }}
                >
                    <div style={{ flex: 1 }}></div>

                    <div
                        style={{
                            flex: 1,
                            textAlign: "left",
                            paddingRight: "20px",
                            paddingLeft: screenSize.isMobile ? "20px" : "50px",
                        }}
                    >
                        <div style={{flex: 1, textAlign: 'left'}}>
                            <p style={{ fontWeight: 400 }}><a style={linkStyle} onClick={() => navigate('/galleries')}>BACK to galleries</a></p>
                        </div>
                        <p style={{ fontWeight: 600, textTransform: "uppercase", marginTop: '100px', }}>
                            {gallery.title}
                        </p>
                        <p className="date-class">
                            {gallery.date_posted}
                        </p>
                        {gallery.year && (
                            <p style={{ fontWeight: 600, fontSize: "10px" }}>{gallery.year}</p>
                        )}
                        {gallery.description && (
                            <p
                                style={{
                                    width: screenSize.isMobile ? "95%" : "60%",
                                    marginBottom: "10px",
                                    fontWeight: 400,
                                }}
                            >
                                {gallery.description}
                            </p>
                        )}
                    </div>
                </div>

                {/* Image Grid */}
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: screenSize.isDesktop
                            ? "repeat(8, 1fr)"
                            : screenSize.isTablet
                                ? "repeat(4, 1fr)"
                                : "repeat(2, 1fr)",
                        gap: screenSize.isMobile ? "10px" : "15px",
                        padding: screenSize.isMobile
                            ? "0 10px"
                            : screenSize.isTablet
                                ? "0 30px"
                                : "0 50px",
                        marginBottom: "80px",
                    }}
                >
                    {images.map((image: string, index: number) => (
                        <div
                            key={index}
                            style={{
                                width: "100%",
                                aspectRatio: "1 / 1",
                                overflow: "hidden",
                                cursor: "pointer",
                            }}
                            onClick={() => {
                                setPhotoIndex(index);
                                setLightboxOpen(true);
                            }}
                        >
                            <img
                                src={image}
                                alt={`Gallery Image ${index + 1}`}
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    transition: "transform 0.3s ease",
                                }}
                                onMouseEnter={(e) =>
                                    (e.currentTarget.style.transform = "scale(1.05)")
                                }
                                onMouseLeave={(e) =>
                                    (e.currentTarget.style.transform = "scale(1)")
                                }
                            />
                        </div>
                    ))}
                </div>

                {/* Simple Lightbox */}
                {lightboxOpen && (
                    <div
                        onClick={() => setLightboxOpen(false)}
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "rgba(0, 0, 0, 0.9)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 9999,
                            overflowY: "auto",
                        }}
                    >
                        <img
                            src={images[photoIndex]}
                            alt=""
                            style={{
                                maxWidth: "90%",
                                maxHeight: "90%",
                                objectFit: "contain",
                                userSelect: "none",
                            }}
                            onClick={(e) => e.stopPropagation()}
                        />
                        {/* Arrows */}
                        {images.length > 1 && (
                            <>
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setPhotoIndex(
                                            (photoIndex + images.length - 1) % images.length
                                        );
                                    }}
                                    style={arrowStyle("left")}
                                >
                                    ‹
                                </button>
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setPhotoIndex((photoIndex + 1) % images.length);
                                    }}
                                    style={arrowStyle("right")}
                                >
                                    ›
                                </button>
                            </>
                        )}
                    </div>
                )}
            </div>

            <Footer />
        </div>
    );
}

function arrowStyle(side: "left" | "right"): React.CSSProperties {
    return {
        position: "absolute",
        top: "50%",
        [side]: "30px",
        transform: "translateY(-50%)",
        background: "none",
        color: "white",
        fontSize: "3rem",
        border: "none",
        cursor: "pointer",
        userSelect: "none",
    };
}

export default Gallery;
